import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /**
   * Initial expanded state.
   *
   * @type {Boolean|String}
   * @default false
   */
  expanded: booleanAttribute(),
  /**
   * Activator label shown when collapsed. Ignored when the title slot is provided.
   *
   * @type {String}
   * @default "Show more"
   */
  title: {
    type: String,
    default: "Show more",
  },
  /**
   * Activator label shown when expanded. Falls back to title when not set.
   *
   * @type {String}
   * @default undefined
   */
  expandedTitle: {
    type: String,
    default: undefined,
  },
  /**
   * Colour for the activator label and caret. Overrides --sp-comp-expandable-area-activator-color.
   *
   * @type {String}
   * @default undefined
   */
  color: {
    type: String,
    default: undefined,
  },
});
